import { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';

import Notice from '@cartwhl/ui/molecules/Notice';
import * as noticesStore from '@cartwhl/common/stores/noticesStore';

function useVisualTop(padding = 16) {
  const [top, setTop] = useState(0);

  useEffect(() => {
    const vv = window.visualViewport;

    const update = () => setTop((vv?.offsetTop || 0) + padding);
    update(); // 1st paint

    vv?.addEventListener('resize', update); // fires on kbd open
    vv?.addEventListener('scroll', update); // panning / zoom
    window.addEventListener('orientationchange', update);

    return () => {
      vv?.removeEventListener('resize', update);
      vv?.removeEventListener('scroll', update);
      window.removeEventListener('orientationchange', update);
    };
  }, [padding]);

  return top;
}

export default function Notices() {
  const { notices } = useSnapshot(noticesStore.state);
  const top = useVisualTop();

  return (
    <div
      style={{ top: `calc(${top}px + env(safe-area-inset-top))` }}
      className="z-100 pointer-events-none fixed left-0 w-full px-4"
    >
      {notices.map((notice) => (
        <Notice
          key={notice.id}
          removeCallback={() => noticesStore.remove(notice.id)}
          {...notice}
        />
      ))}
    </div>
  );
}
